import { feedback, feedbackV2 } from '@ecosystem/newron-design-system'
import { useDispatch, useSelector } from 'react-redux'
import {
  getSelectedDefaultDropdownMode,
  getSelectedDefaultKBQBrands,
  getSelectedDefaultKBQChannelVisited,
  getSelectedDefaultKBQPurchasedRetailers,
} from 'reducers/KBQ/selector'
import { RootState } from 'reducers/store'

export const useKBQSelectedValueByPath = () => {
  const { Alert: InlineAlert } = feedbackV2
  const { DotsLoader } = feedback
  const dispatch = useDispatch()
  const pathName = window.location.pathname.split('/').pop()
  const defaultBrand = useSelector((state: RootState) =>
    getSelectedDefaultKBQBrands(state, { id: pathName! })
  )?.defaultBrand
  const defaultChannelVisitor = useSelector((state: RootState) =>
    getSelectedDefaultKBQChannelVisited(state, { id: pathName! })
  )?.defaultChannel
  const defaultRetailer = useSelector((state: RootState) =>
    getSelectedDefaultKBQPurchasedRetailers(state, { id: pathName! })
  )?.defaultRetailer
  const selectedMode = useSelector((state: RootState) =>
    getSelectedDefaultDropdownMode(state, { id: pathName! })
  )?.mode
  return {
    InlineAlert,
    DotsLoader,
    dispatch,
    pathName,
    defaultBrand,
    defaultChannelVisitor,
    defaultRetailer,
    selectedMode,
  }
}
